export default "__VITE_ASSET__7a9edb4b__"